module.exports = __webpack_public_path__ + "images/icons_v2/brightness-low-eb627a04.svg";